import dayjs from "dayjs";
import React, { useEffect, useState } from "react";

import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";

const RightTable = ({ tableRightList, loading, onAmountChange , onRefNoChange }) => {
  const [selectedToggle, setSelectedToggle] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);

  const handleSelectToggle = (index, checked) => {
    setSelectedToggle((prev) => {
      const updated = [...prev];
      updated[index] = checked;
      console.log("updated::", updated);
      return updated;
    });
  };

  useEffect(() => {
    console.log("selectedRow in right table:", selectedRow);
    const selectedAmount = selectedRow?.BalAmt;
    onAmountChange?.(selectedAmount);
    const selectedRefNo = selectedRow?.INV;
    onRefNoChange?.(selectedRefNo);
  }, [selectedRow]);

  return (
    <div className="h-[40vh] w-full overflow-auto  ">
      <h2 className="text-md text-gray-800 mt-2 mb-1">Invoices</h2>

      <table className="relative text-xs border-collapse w-full">
        <thead>
          <tr className="">
            <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
              Select
            </th>
            <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
              Account
            </th>
            <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
              BalAmt
            </th>
            {/* <th className="z-20 bg-gray-100 font-normal sticky top-0 border px-2 py-1">
              Type
            </th> */}
            <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
              Ref No
            </th>
            <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
              Inv Date
            </th>
            <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
              Description
            </th>
            <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
              FC Bal Amt
            </th>
            <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
              job Code
            </th>
            <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
              CUR
            </th>
          </tr>
        </thead>

        <tbody>
          {loading ? (
            <tr>
              <td colSpan={11} className="py-6 text-center">
                <div className="flex items-center justify-center gap-2 text-gray-600">
                  <span className="h-5 w-5 animate-spin rounded-full border-2 border-gray-300 border-t-blue-600"></span>
                  Loading data...
                </div>
              </td>
            </tr>
          ) : tableRightList?.length > 0 ? (
            tableRightList.map((row, index) => (
              <tr key={index} className="text-xs">
                <td className="border w-24 bg-white  text-center">
                  <input
                    type="radio"
                    name="rightTableRow"
                    checked={selectedRow?.INV === row?.INV}
                    onChange={() => setSelectedRow(row)}
                  />
                </td>
                <td className="border bg-white px-2 py-1 text-right">
                  {row?.account ?? "-"}
                </td>
                <td className="border bg-white px-2 py-1 text-right">
                  {row?.BalAmt ?? "-"}
                </td>
                {/* <td className={`border  px-2 py-1 text-center ${row?.TYPE==='C'?'bg-red-500 text-white':'bg-green-500 text-white'}`}>
                  {row?.TYPE ?? "-"}
                </td> */}

                <td className="border bg-white px-2 py-1 ">
                  {row?.INV ?? "-"}
                </td>
                <td className="border bg-white px-2 py-1 text-left cursor-pointer">
                  {row?.INVDATE ? dayjs(row.INVDATE).format("DD/MM/YYYY") : "-"}
                </td>
                <td className="border bg-white px-2 py-1 text-left">
                  {row?.DESCR ?? "-"}
                </td>

                <td className="border bg-white px-2 py-1 text-right">
                  {row?.FCBalAmt ?? "-"}
                </td>
                <td className="border bg-white px-2 py-1 text-left">
                  {row?.job_code ?? "-"}
                </td>
                <td className="border bg-white px-2 py-1 text-left">
                  {row?.CUR ?? "-"}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={11} className="text-center py-4 text-gray-500">
                No data available
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default RightTable;
